
import {SET_PLANE_MACROS} from 'constants/action-types.js';
import {SET_PLANAR_GRADIENT_COLOR} from 'constants/action-types.js';
import {SET_PLANAR_OPACITY} from 'constants/action-types.js';
import {SET_SELECTED_PLANAR_PARAMETERS} from 'constants/action-types.js';
import {SET_FILTERED_PLANAR_PARAMETERS} from 'constants/action-types.js';
import {SET_PLANAR_MACRO_TO_SHOW} from 'constants/action-types.js';
import {SET_PLANAR_REGION_MODE} from 'constants/action-types.js';


export default (state = {
    filteredParameters: {},
    selectedParameters: {},
    regionMode: {},
    macroToShow: {},
    gradientColors: {},
    opacities: {}, macros: {}}, action) => {
    switch (action.type) {
    case SET_PLANAR_REGION_MODE:
        let regionMode  = {... state.regionMode};
        regionMode[action.payload.id] = action.payload.isRegionMode;
        return {
            ... state,
            regionMode
        };
    case SET_PLANAR_MACRO_TO_SHOW:
        let macroToShow  = {... state.macroToShow};
        macroToShow[action.payload.id] = action.payload.macro;
        return {
            ... state,
            macroToShow
        };
    case SET_FILTERED_PLANAR_PARAMETERS:
        let filteredParameters = {... state.filteredParameters};
        filteredParameters[action.payload.id] = action.payload.filtered;
        return {
            ... state,
            filteredParameters
        };
    case SET_SELECTED_PLANAR_PARAMETERS:
        let selectedParameters = {... state.selectedParameters};
        selectedParameters[action.payload.id] = action.payload.selected;
        return {
            ... state,
            selectedParameters
        };
    case SET_PLANAR_GRADIENT_COLOR:
        let gradientColors = {... state.gradientColors};
        gradientColors[action.payload.id] = action.payload.color;
        return {
            ...state,
            gradientColors
        };
    case SET_PLANAR_OPACITY:
        let opacities = {... state.opacities};
        opacities[action.payload.id] = action.payload.opacity;
        return {
            ...state,
            opacities
        };
    case SET_PLANE_MACROS:
        let macros = state.macros || {};
        macros[action.payload.id] = action.payload.macros;
        return {
            ... state,
            macros
        };
    default:
        return state;
    }
}
